import { StoryType } from '../story/models/story-type.enum';
import { StoryChapterThumbnail } from '../story/models/story-chapter-thumbnail.model';
import { storyType } from '../story/state/story-type';
// thumbnail urls
export var Thumbnail;
(function (Thumbnail) {
    function generateThumbnailUrls(storyIdChapterIdList) {
        return storyIdChapterIdList.reduce(function (acc, _a) {
            var originalChapterId = _a.originalChapterId, newChapterId = _a.newChapterId, originalStoryId = _a.originalStoryId;
            var isBookmark = StoryType.Bookmark === storyType(originalStoryId);
            var pathForStoryType = isBookmark ? 'bookmarks' : 'modules';
            var urlBase = "/thumbs/" + pathForStoryType + "/" + originalStoryId;
            var thumbnail = new StoryChapterThumbnail();
            thumbnail.storyId = originalStoryId;
            thumbnail.chapterId = originalChapterId;
            thumbnail.urls = {
                small: urlBase + "/small/chapters/" + originalChapterId + ".jpg",
                large: urlBase + "/large/chapters/" + originalChapterId + ".jpg"
            };
            acc.set(newChapterId, thumbnail);
            return acc;
        }, new Map());
    }
    Thumbnail.generateThumbnailUrls = generateThumbnailUrls;
})(Thumbnail || (Thumbnail = {}));
